var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.editing)?_c('div',[_c('HtmlEditor',{attrs:{"value":_vm.component.html},on:{"change":_vm.change}})],1):_c('div',[_c('pre',{staticClass:"pre-scrollable"},[_c('code',[_vm._v(_vm._s(_vm.component.html))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }